import React from 'react';
import { Spinner } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { lang, withRouter } from 'src/helpers';

import model from './model';
import StripePaymentMethod from './StripePaymentMethod';

class List extends BaseComponent {
  componentDidMount() {
    this.getModel().subscribe(this.subscription);
  }

  getModel = () => this.props.model || model;

  componentWillUnmount() {
    this.getModel().unsubscribe(this.subscription);
  }
  render() {
    const model = this.getModel();
    const { loading } = model.getApiState('stripeList');
    const cards = model.state.cards;
    return (
      <>
        {loading ? (
          <Spinner />
        ) : cards.length === 0 ? (
          <div>{lang.t('No results yet')}</div>
        ) : (
          cards.map((card) => (
            <div key={card.id}>
              {card.type === 'card' && (
                <StripePaymentMethod
                  data={card}
                  onClick={model.stripeActive}
                  onDelete={model.stripeRemove}
                />
              )}
              {card.type === 'blik' && (
                <StripePaymentMethod
                  data={card}
                  onClick={model.stripeActive}
                  onDelete={model.stripeRemove}
                />
              )}
            </div>
          ))
        )}
      </>
    );
  }
}

export default withRouter(List);
